
const algoliaApplicationId = 'S8IXV2L775'
const algoliaSearchOnlyApiKey = '9938bf14b5bd8920ba5b30d4ed22eb09'
const algoliaAdminApiKey = '492326efe5c99d498b8e21245e5c85f0'

export {
  algoliaApplicationId,
  algoliaSearchOnlyApiKey,
  algoliaAdminApiKey
}

